import HeroSection from "./components/HeroSection";
import IntroductionSection from "./components/IntroductionSection";
import ServicesSection from "./components/ServicesSection";
import ValuesSection from "./components/ValuesSection";
import MethodologySection from "./components/MethodologySection";
import ContactSection from "./components/ContactSection";
import AnimatedSection from "@/components/base/AnimatedSection";

export default function Home() {
  return (
    <main>
      <HeroSection />
      <AnimatedSection>
        <IntroductionSection />
      </AnimatedSection>
      <AnimatedSection>
        <ServicesSection />
      </AnimatedSection>
      <AnimatedSection>
        <ValuesSection />
      </AnimatedSection>
      <AnimatedSection>
        <MethodologySection />
      </AnimatedSection>
      <AnimatedSection>
        <ContactSection />
      </AnimatedSection>
    </main>
  );
}